/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	
	var _isSP;
	
	var windowW = window.innerWidth;
	var prewidth = window.innerWidth; //preload
	
	(0, _module.preload)(); //showMovie
	// import {showMovie} from "../include/module";
	// showMovie();
	//toggleHeader
	// import {toggleHeader} from "../include/module";
	// toggleHeader();
	// $(window).on('resize load' , function() {
	//   if(windowW <= 1024){
	//     _isSP = true;
	//   } else {
	//     _isSP = false;
	//   };
	//   //リサイズ処理 ブレイクポイントを跨いだらリロード
	//   var nowWidth = window.innerWidth;
	//   if(prewidth !== nowWidth){
	//     if(prewidth < 1025) {
	//       if(nowWidth >= 1025){
	//         location.reload();
	//       }
	//     }else {
	//       if(nowWidth < 1025){
	//         location.reload();
	//       }
	//     }
	//   };
	// });
	
	$(window).on('load', function () {
	  // scrollIndexAnime();
	  // topSlide();
	  discSlide();
	}); // ------------------------------------------------------------------------
	// discSlide
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var discSlide = function discSlide() {
	  var discSwiper;
	  var options = {}; //1枚の時
	
	  if ($(".index-Slider_Item").length == 1) {
	    options = {
	      // autoplay: {
	      //   delay: 4000,
	      //   disableOnInteraction: false
	      // },
	      autoHeight: false,
	      // loop: true,
	      // loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
	      // grabCursor: true,
	      watchOverflow: true,
	      //スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
	      speed: 1000,
	      // width: 760,
	      slidesPerView: 1,
	      breakpoints: {
	        1024: {
	          spaceBetween: 10,
	          slidesPerView: 1
	        }
	      },
	      pagination: {
	        el: '.index-Slider_Pagination',
	        clickable: true
	      },
	      on: {}
	    };
	  } else {
	    options = {
	      autoplay: {
	        delay: 4000,
	        disableOnInteraction: false
	      },
	      autoHeight: false,
	      loop: true,
	      loopAdditionalSlides: 1,
	      //一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
	      grabCursor: true,
	      watchOverflow: true,
	      //スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
	      speed: 1000,
	      // width: 760,
	      slidesPerView: 1,
	      breakpoints: {
	        1024: {
	          spaceBetween: 10,
	          slidesPerView: 1
	        }
	      },
	      pagination: {
	        el: '.index-Slider_Pagination',
	        clickable: true
	      },
	      on: {}
	    };
	  }
	
	  discSwiper = new Swiper('.index-Slider_Container', options);
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preload = void 0;
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	exports.preload = preload;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js